import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AboutUs from './AboutUs';

const Header = () => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    setIsActive(true);
  }, []);

  // Common stroke properties
  const strokeProps = {
    stroke: "#ff9447",
    strokeWidth: "1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  };

  return (
    <header className="bg-zinc-950 border-b border-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <svg 
                width="50px" 
                height="50px" 
                viewBox="-5 0 72 72" 
                xmlns="http://www.w3.org/2000/svg"
                className={isActive ? 'active' : ''}
              >
                <g id="Group_1" data-name="Group 1" transform="translate(-633 -405)">
                  <g id="Rectangle-29">
                    <path id="Path_48" data-name="Path 48" d="M666.8,477h-5.6a4.083,4.083,0,0,1-4.056-3.943c0-.14-.48-15.1-.238-30.6.5-32.053,3.532-35.186,4.674-36.365a3.237,3.237,0,0,1,4.85,0c1.142,1.18,4.174,4.312,4.667,36.365.238,15.5-.239,30.46-.244,30.609A4.087,4.087,0,0,1,666.8,477Zm-2.791-67.509c-2.874,5.39-3.742,36.233-2.862,63.446L666.8,473C667.736,445.728,666.877,414.882,664.005,409.491Z" fill="#f0bb7f" className="svg-elem-1" {...strokeProps} />
                  </g>
                  <g id="Rectangle-30">
                    <path id="Path_49" data-name="Path 49" d="M675,453v14h-4V453h4m2-4h-8a2,2,0,0,0-2,2v18a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V451a2,2,0,0,0-2-2Z" fill="#f0bb7f" className="svg-elem-2" {...strokeProps} />
                  </g>
                  <g id="Rectangle-30-Copy">
                    <path id="Path_50" data-name="Path 50" d="M657,453v14h-4V453h4m2-4h-8a2,2,0,0,0-2,2v18a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V451a2,2,0,0,0-2-2Z" fill="#f0bb7f" className="svg-elem-3" {...strokeProps} />
                  </g>
                  <g id="Line-Copy-5_3_">
                    <path id="Path_51" data-name="Path 51" d="M677,477a2,2,0,0,1-2-2V465a2,2,0,0,1,4,0v10A2,2,0,0,1,677,477Z" fill="#f0bb7f" className="svg-elem-4" {...strokeProps} />
                  </g>
                  <g id="Line-Copy-6_1_">
                    <path id="Path_52" data-name="Path 52" d="M651,477a2,2,0,0,1-2-2V465a2,2,0,0,1,4,0v10A2,2,0,0,1,651,477Z" fill="#f0bb7f" className="svg-elem-5" {...strokeProps} />
                  </g>
                  <g id="Line-Copy-7_1_">
                    <path id="Path_53" data-name="Path 53" d="M635,473a2,2,0,0,1-2-2V430.988a2,2,0,0,1,4,0V471A2,2,0,0,1,635,473Z" fill="#f0bb7f" className="svg-elem-6" {...strokeProps} />
                  </g>
                  <g id="Line-Copy-10">
                    <path id="Path_54" data-name="Path 54" d="M642,457a2,2,0,0,1-2-2V439a2,2,0,0,1,4,0v16A2,2,0,0,1,642,457Z" fill="#f0bb7f" className="svg-elem-7" {...strokeProps} />
                  </g>
                  <g id="Line-Copy-11">
                    <path id="Path_55" data-name="Path 55" d="M686,457a2,2,0,0,1-2-2V439a2,2,0,0,1,4,0v16A2,2,0,0,1,686,457Z" fill="#f0bb7f" className="svg-elem-8" {...strokeProps} />
                  </g>
                  <g id="Line-Copy-9">
                    <path id="Path_56" data-name="Path 56" d="M667.175,423h-6a2,2,0,0,1,0-4h6a2,2,0,0,1,0,4Z" fill="#f0bb7f" className="svg-elem-9" {...strokeProps} />
                  </g>
                  <g id="Line-Copy-8">
                    <path id="Path_57" data-name="Path 57" d="M693,473a2,2,0,0,1-2-2V432.988a2,2,0,0,1,4,0V471A2,2,0,0,1,693,473Z" fill="#f0bb7f" className="svg-elem-10" {...strokeProps} />
                  </g>
                  <g id="Rectangle-32">
                    <path id="Path_58" data-name="Path 58" d="M649,458v9H637v-9h12m2-4H635a2,2,0,0,0-2,2v13a2,2,0,0,0,2,2h16a2,2,0,0,0,2-2V456a2,2,0,0,0-2-2Z" fill="#f0bb7f" className="svg-elem-11" {...strokeProps} />
                  </g>
                  <g id="Rectangle-32-Copy">
                    <path id="Path_59" data-name="Path 59" d="M691,457v9H679v-9h12m2-4H677a2,2,0,0,0-2,2v13a2,2,0,0,0,2,2h16a2,2,0,0,0,2-2V455a2,2,0,0,0-2-2Z" fill="#f0bb7f" className="svg-elem-12" {...strokeProps} />
                  </g>
                </g>
              </svg>
              <span className="ml-2 text-xl font-bold font-mono text-white">Innominate Appraisal</span>
            </Link>
          </div>
            <nav>
              <div className="flex items-center space-x-3 md:space-x-4 font-mono ">
              <a
                href="/api/docs/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-orange-400 px-2 md:px-3 py-1.5 md:py-2 text-base md:text-lg transition-colors font-mono"
                onClick={(e) => {
                  e.preventDefault();
                  window.open('/api/docs/', '_blank', 'noopener,noreferrer');
                }}
              >
                API
              </a>
                <AboutUs />
              </div>
            </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
